import {getAuthData} from './Auth'

export default class UserInfo {
    build = async () => {
        try {
            //Check for cognito user data
            const cognitoUser = await getAuthData()
            if(cognitoUser.user)
                await this.fetchUserDataFromRDS(cognitoUser)
            else
                throw 'user session data not found'

        } catch (err) {
            console.error(err);
        }
    }

    //Retrieve data from Cognito/AWS if cognito session is found
    fetchUserDataFromRDS = async (cognito) => {

        const info = {
          contactId: null,
          publicId: null,
          telehealthEnabled: false,
          userId: null,
          userImageUrl: null,
          userLevel: 0,
          userName: 'Anonymous User',
          userStatus: null,
          trainedE1: null,
          trainedF1: null,
          trainedM1: null,
          trainedM2: null,
          trainedM3: null,
          allCredentials: null,
          expireGTS: null,
          ppAccess: false,
          isInstructor: false,
          Account: {
            Name: 'Default Account',
            Street: null,
            City: null,
            State: null,
            PostalCode: null,
            Latitude: null,
            Longitude: null
          }
        }
        this.user = info
    }

}